<template>
    <div class="right">
        <slot />
    </div>
</template>

<script>
export default {
    name: 'BaseDetails',
};
</script>

<style scoped lang="scss">
.right {
    background-color: var(--main-background-light-light);
    border-radius: 10px;
    padding: 2rem;

    @media screen and (max-width: 992px) {
        order: 1;
        border-radius: unset;
    }

    &::v-deep > .separator {
        margin: 2rem 0 2rem 0;
    }
}

.subtext {
    margin-top: -5px;
}

::v-deep .separator {
    display: flex;
    align-items: center;
    text-align: center;

    &::before {
        content: '';
        flex: 1;
        border-bottom: 1px solid #000;
    }

    &::after {
        content: '';
        flex: 1;
        border-bottom: 1px solid #000;
    }

    &:not(:empty) {
        &::before {
            margin-right: .25em;
        }

        &::after {
            margin-left: .25em;
        }
    }
}

::v-deep .split {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
}
</style>
